import React from 'react';
import { Card, CloseButton, OptionButton, Overlay } from './Menu.styles';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '#/common/components/FAIcon';
import useApplicationPickerItems from '#/app/hooks/useApplicationPickerItems';
import If from '#/common/components/If';

interface ApplicationPickerCardProps {
  onClose: () => void;
  opened?: boolean;
  variant?: 'desktop' | 'mobile';
}

const ApplicationPickerCard: React.FC<ApplicationPickerCardProps> = ({
  onClose,
  opened = false,
  variant = 'desktop',
}) => {
  const applicationPickerItems = useApplicationPickerItems();

  const handlePickerItemClick = (url: string) => {
    onClose();
    if (url) {
      // This will reload the page
      window.location.href = url;
    }
  };

  return (
    <If condition={opened}>
      <Overlay onClick={onClose} />
      <Card variant={variant} w={320} type="appPicker">
        {variant === 'mobile' && (
          <CloseButton onClick={() => onClose()}>
            <FAIcon icon="xmark" color={color('secondary', 'dark2')} />
          </CloseButton>
        )}
        {applicationPickerItems.map((item) => (
          <OptionButton
            key={item.id}
            size="sm"
            className={item.cssClass}
            onClick={() => handlePickerItemClick(item.url)}>
            <FAIcon icon={item.icon} color={color('custom', 'iconGray')} />
            <span className="item-text">{item.name}</span>
          </OptionButton>
        ))}
      </Card>
    </If>
  );
};

export default ApplicationPickerCard;
